import React, { useEffect, useState } from 'react'

import { SimpleSelectableOption } from '@/components/Shared/SimpleSelectableOption'
import type {
  CMSProgramMealScheduleOption,
  CMSProgramMealScheduleOptionGroup,
} from '@/types/sanity'

import './MealScheduleOptions.scss'
import { RichText } from './RichText'

type Props = {
  config: CMSProgramMealScheduleOptionGroup
  onChange?: (option: CMSProgramMealScheduleOption) => void
}

export const MealScheduleOptions: React.FC<Props> = ({ config, onChange }) => {
  const { label, options } = config
  const [selectedOption, setSelectedOption] = useState(
    options.find((option) => option.selected) || options[0],
  )

  useEffect(() => {
    onChange?.(selectedOption)
  }, [selectedOption])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event?.target?.value
    const newSelectedOption = options.find(
      (option) => option.value === newValue,
    )
    if (newSelectedOption) {
      setSelectedOption(newSelectedOption)
    }
  }

  return (
    <div className="flexible-program-meal-schedule-options">
      {label && (
        <div className="flexible-program-meal-schedule-options__label type-eyebrow">
          {label}
        </div>
      )}
      <div className="flexible-program-meal-schedule-options__content">
        {options.map((option) => (
          <SimpleSelectableOption
            id={option._key}
            name={config._id}
            value={option.value}
            type="radio"
            key={option._key}
            label={option.label}
            checked={option._key === selectedOption._key}
            onChange={handleChange}
          />
        ))}
      </div>
      {selectedOption.description && (
        <RichText content={selectedOption.description} />
      )}
    </div>
  )
}
